/* eslint-disable no-restricted-syntax */

import HfReactHelper from 'js/sign-components/common/hf-react-helper';
import { defineMessages } from 'react-intl';
import { intl } from 'hellospa/common/hs-intl-provider';

const messages = defineMessages({
  products: {
    id: '',
    description: 'navbar header text, when clicked opens dropdown',
    defaultMessage: 'Products',
  },
  developers: {
    id: '',
    description:
      'dropdown menu link, when clicked opens developers page, shows helpful guide for developers to integrate our product',
    defaultMessage: 'Developers',
  },
  security: {
    id: '',
    description: 'navbar link text, when clicked opens security page',
    defaultMessage: 'Security',
  },
  pricing: {
    id: '',
    description: 'navbar link text, when clicked opens pricing page',
    defaultMessage: 'Pricing',
  },
  logIn: {
    id: '',
    description: 'navbar button text for logging in',
    defaultMessage: 'Log in',
  },
  faxForFree: {
    id: '',
    description: 'navbar CTA button text for signing up to fax',
    defaultMessage: 'Fax for free',
  },
  signUp: {
    id: '',
    description: 'navbar CTA button text for signing up',
    defaultMessage: 'Sign Up',
  },
});

const Constants = {
  topBarScreenThreshhold: 1024, // pixels

  // Navigation links (excluding Products dropdown which is handled separately)
  navLinks: [
    {
      key: 'developers',
      text: intl.formatMessage(messages.developers),
      url: 'https://developers.hellosign.com/api/reference/fax/',
      daCategory: 'menu',
      daAction: 'developers',
    },
    {
      key: 'security',
      text: intl.formatMessage(messages.security),
      url: 'https://www.hellosign.com/legal/hellofax-security',
      daCategory: 'menu',
      daAction: 'security',
    },
    {
      key: 'pricing',
      text: intl.formatMessage(messages.pricing),
      url: HfReactHelper.urlHelper(
        'info/pricing',
        HfReactHelper.HfSites.SITE_CODE_HF,
      ),
      daCategory: 'menu',
      daAction: 'pricing',
    },
  ],

  // Products dropdown config
  productsDropdown: {
    key: 'products',
    text: intl.formatMessage(messages.products),
    daCategory: 'menu',
    daAction: 'products',
  },

  // Button text
  buttons: {
    logIn: intl.formatMessage(messages.logIn),
    faxForFree: intl.formatMessage(messages.faxForFree),
    signUp: intl.formatMessage(messages.signUp),
  },

  // Login URL
  loginUrl: HfReactHelper.urlHelper(
    'account/logIn',
    HfReactHelper.HfSites.SITE_CODE_HF,
  ),

  // Signup URL
  signupUrl: HfReactHelper.urlHelper(
    'account/signUp',
    HfReactHelper.HfSites.SITE_CODE_HF,
  ),

  // Legacy topBarData for backward compatibility (will be phased out)
  topBarData: [],
};

export default Constants;
